import { defineComponent, onMounted, createApp, ref, reactive, computed, watch } from 'vue'
import Input from 'ant-design-vue/lib/input'
import Select from 'ant-design-vue/lib/select'
import Form from 'ant-design-vue/lib/form'
import Modal from 'ant-design-vue/lib/modal'
import Button from 'ant-design-vue/lib/button'
import Message from 'ant-design-vue/lib/message'
import Popconfirm from 'ant-design-vue/lib/popconfirm'
import { useRouter } from 'vue-router'

const CreateNewConnection = defineComponent((props: any) => {
    const data = reactive({
        visible: true,
        value: '',
        confirmLoading: false,
    })
    return () => <Modal
        visible={data.visible}
        title='连接到?'
        onCancel={() => {
            data.visible = false;
            props.onClose && props.onClose();
        }}
        okText='确定'
        cancelText='取消'
        confirmLoading={data.confirmLoading}
        onOk={(val) => {
            if (!data.value) {
                return Message.error('请输入链接名称');
            }
            if (!/^[a-zA-Z0-9_]{0,}$/.test(data.value)) {
                return Message.error('不允许输入中文或特殊字符');
            }
            data.confirmLoading = true;
            fetch(process.env.VUE_APP_BASE_API+'/create/user/'+data.value, { method: 'post' }).then(v => v.json()).then(v => {
                if (v.code == 0) {
                    data.confirmLoading = false;
                    return Message.error(v.msg)
                } else {
                    data.visible = false;
                    props.onClose && props.onClose(data.value);
                }
            })
        }}
    >
        <Form label-col={{span: 5}} wrapper-col={{span: 19}}>
            <Form.Item label='连接名'>
                <Input onInput={e => data.value = e.target.value} />
            </Form.Item>
        </Form>
    </Modal>
})
CreateNewConnection.props = {
    onClose: Function
}


const SelectServer = defineComponent((props: any) => {
    const router = useRouter();
    const data = reactive({
        url: '',
        user: '',
        userList: []
    })
   
    watch(() => props.visible, val => {
        if (val == true) {
            getData();
        }
    })

    const getData = () => {
        fetch(process.env.VUE_APP_BASE_API+'/user').then(v => v.json()).then(v => {
            data.userList = v.data;
        })
    }
    
    const createNew = () => {
        SelectServer.create(() => {
            getData();
        });
    }
    const deleteUser = (name: string, index: number) => {
        Modal.confirm({
            cancelText: '危险提示',
            content: '确定删除吗',
            okText: '确定',
            // 此处因为antd没有对应声明文件，暂时这样写
            ...({cancelText: "取消"} as any),
            onOk() {
                console.log(index)
                fetch(process.env.VUE_APP_BASE_API+'/user/'+name, { method: 'delete' }).then(v => v.json()).then(v => {
                    data.userList.splice(index, 1);
                    Message.success('删除成功');
                }).catch(err => {
                    Message.error('删除出错');
                })
            }
        })
    }
    return () => <Modal
        visible={props.visible}
        title='连接到?'
        onCancel={() => {
            props.onClose && props.onClose();
        }}
        onOk={(val) => {
            if (!data.user) {
                return Message.error('请选择角色');
            }
            router.replace('/?key='+data.user)
            props.onClose && props.onClose(data.user);
        }}
    > 
        <Form label-col={{span: 5}} wrapper-col={{span: 19}}>
            <Form.Item label='选择角色'>
                <Select value={data.user} onChange={val => {
                    data.user = val;
                }} >
                    {data.userList.map((v: any, index: number) => {
                        return <Select.Option value={v} key={v}>
                            {v}
                            {/* <Popconfirm
                                title="确定删除此链接吗"
                                ok-text='确定'
                                cancel-text='取消'
                                onConfirm={() => {

                                }}> */}
                                {v != data.user && <div class='select-right-option' style='float:right;color:red;font-size: 12px;' onClick={e => {
                                    e.stopPropagation();
                                    deleteUser(v, index);
                                }}>删除</div>}
                            {/* </Popconfirm> */}
                        </Select.Option>
                    })}
                    
                </Select>
                <div>
                    <Button onClick={createNew}>创建新连接</Button>
                </div>
            </Form.Item>
        </Form>
        
    </Modal>
})
SelectServer.props = {
    visible: Boolean,
    onClose: Function
}
SelectServer.create = (sucess?: Function) => {
    var div = document.createElement('div')
    document.body.appendChild(div)
    var $app = createApp(<CreateNewConnection onClose={(val: string) => {
        if (val) {
            sucess && sucess();
        }
        setTimeout(() => {
            $app.unmount();
        }, 300);
    }} />);
    $app.mount(div)
}
export default SelectServer;